import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBookOpen, FiCheckCircle } = FiIcons;

const CalculatorGuide = () => {
  const tips = [
    {
      title: "Daily Revenue",
      description: "Use your average daily sales in RM, excluding exceptional days like holidays."
    },
    {
      title: "Food & Beverage Costs",
      description: "Include all ingredients, beverages, and disposable items costs for a typical day."
    },
    {
      title: "Labor Costs",
      description: "Calculate daily wages, including kitchen staff, servers, and management."
    },
    {
      title: "Rent & Utilities",
      description: "Divide monthly rent and utility bills by 30 for daily costs."
    },
    {
      title: "Other Expenses",
      description: "Include marketing, maintenance, and miscellaneous daily costs."
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-white rounded-3xl shadow-xl p-8 border border-slate-200 mt-8"
    >
      <div className="flex items-center gap-3 mb-6">
        <div className="bg-gradient-to-r from-teal-500 to-emerald-600 p-2 rounded-xl">
          <SafeIcon icon={FiBookOpen} className="text-xl text-white" />
        </div>
        <h3 className="text-2xl font-bold text-slate-800">How to Use This Calculator</h3>
      </div>

      <div className="space-y-6">
        {tips.map((tip, index) => (
          <motion.div
            key={tip.title}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.4, delay: 0.1 * index }}
            className="flex gap-4 items-start"
          >
            <div className="mt-1">
              <SafeIcon icon={FiCheckCircle} className="text-emerald-500 text-xl" />
            </div>
            <div>
              <h4 className="font-semibold text-slate-800 mb-1">{tip.title}</h4>
              <p className="text-slate-600 text-sm leading-relaxed">
                {tip.description}
              </p>
            </div>
          </motion.div>
        ))}

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
          className="mt-6 p-4 bg-gradient-to-r from-blue-50 to-teal-50 rounded-2xl border border-blue-100"
        >
          <p className="text-blue-800 leading-relaxed">
            <strong>Pro Tip:</strong> For the most accurate results, use data from your point-of-sale system and financial records rather than estimates. Consider seasonal variations and local Malaysian holidays when analyzing your profits.
          </p>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default CalculatorGuide;